// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".clear-all{\n\tcursor: pointer;\n}\n", "",{"version":3,"sources":["FilterTagList.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB","file":"FilterTagList.css","sourcesContent":[".clear-all{\n\tcursor: pointer;\n}\n"]}]);
// Exports
module.exports = exports;
